let reseller = (function () {
  const EXPIRE_TIME_WKN = 7 * 24 * 60 * 60; // 1 week
  const RECOMMENDATION_RESELLER_ID = '841';

  function fillInputs(identifier, value) {
    const hiddenInput = document.querySelector(
      "[data-fill-from-storage='" + identifier + "']",
    );
    if (hiddenInput) {
      hiddenInput.value = value;
    }
  }

  function extractCid(cid) {
    let cidRegex = new RegExp('^ch:AFFILIATE.*pl:([^|]+?)([_&].*|$)');
    let matches = cid.match(cidRegex);
    return matches && matches[1] ? matches[1] : false;
  }

  function getFromUrl(urlParamName) {
    let url = new URL(window.location.href);
    let urlParamValue = url.searchParams.get(urlParamName);
    return urlParamValue ? urlParamValue : null;
  }

  function getFromLocalStorage(itemName) {
    let itemValue = localStorage.getItem(itemName);
    return itemValue ? atob(itemValue) : null;
  }

  function getFromSessionStorage(itemName) {
    let itemValue = sessionStorage.getItem(itemName);
    return itemValue ? atob(itemValue) : null;
  }

  function deleteFromSessionStorage(name) {
    sessionStorage.removeItem(name);
  }

  function deleteFromLocalStorage(name) {
    localStorage.removeItem(name);
    localStorage.removeItem(name + '_expire_time');
  }

  function deleteExpired(name) {
    let itemValue = atob(localStorage.getItem(name));
    let itemExpireTime = atob(localStorage.getItem(name + '_expire_time'));
    if (!itemValue || !itemExpireTime) {
      return;
    }
    let timeNow = Date.now();
    if (itemExpireTime < timeNow) {
      deleteFromLocalStorage(name);
    }
  }

  function setSessionStorage(name, value) {
    sessionStorage.setItem(name, btoa(value));
  }

  function setLocalStorage(name, value, expireTime) {
    let timeNow = Date.now();
    localStorage.setItem(name, btoa(value));
    localStorage.setItem(name + '_expire_time', btoa(timeNow + expireTime));
  }

  function handleRecommendation() {
    if (
      typeof window.digitalData !== 'undefined' &&
      window.digitalData?.promotion?.resellerId !== RECOMMENDATION_RESELLER_ID
    ) {
      deleteFromSessionStorage('wkn');
      return;
    }
    let recommendation = getFromUrl('empfehlung') + '';
    let recommender = getFromUrl('empfaenger') + '';
    let wkn = null;

    if (recommendation && recommendation.length === 13) {
      wkn = recommendation;
      if (recommender && recommender.length === 9) {
        wkn += '|' + recommender.substring(0, 6);
      }
      setSessionStorage('wkn', wkn);
    }

    wkn = getFromSessionStorage('wkn');
    if (wkn) {
      fillInputs('wkn', wkn);
    }
  }
  function handleCID() {
    deleteExpired('wkn');

    let cid = getFromUrl('cid');
    let wkn = null;

    if (cid) {
      wkn = extractCid(cid);
      if (wkn) {
        setLocalStorage('wkn', wkn, EXPIRE_TIME_WKN);
      } else {
        deleteFromLocalStorage('wkn');
        return;
      }
    }

    wkn = getFromLocalStorage('wkn');
    if (wkn) {
      fillInputs('wkn', wkn);
    }
  }

  function init() {
    handleCID();
    handleRecommendation();
  }

  return {
    init: init,
  };
})();
reseller.init();
